var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-setting-quality-component p-5" }, [
    _c("div", { staticClass: "room-setting-content-box" }, [
      _c("h6", { staticClass: "room-setting-content-title" }, [
        _vm._v(_vm._s(_vm.$t("displayQuality.title"))),
      ]),
      _c("div", { staticClass: "room-setting-content-text-box" }, [
        _c("p", { staticClass: "room-setting-content-text" }, [
          _vm._v(_vm._s(_vm.$t("displayQuality.text"))),
        ]),
      ]),
      _c("div", { staticClass: "room-setting-input-box" }, [
        _c("div", { staticClass: "room-set-block-btn-box" }, [
          _c(
            "ul",
            _vm._l(_vm.qualityList, function (quality) {
              return _c(
                "li",
                {
                  key: quality.type,
                  class: { selected: _vm.params.videoQuality == quality.type },
                  on: {
                    click: function ($event) {
                      _vm.selectedQuality = quality.type
                    },
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "room-set-block-btn",
                      attrs: { tabindex: "1" },
                    },
                    [_vm._v(_vm._s(quality.name))]
                  ),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
      _c("div", { staticClass: "room-setting-content-text-box" }, [
        _c("p", { staticClass: "room-setting-content-text" }, [
          _c("span", { domProps: { textContent: _vm._s(_vm.qualityText) } }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }